import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, PlayIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
const POSTS = ['https://cdn.magicpatterns.com/patterns/generated-images/151bbf66-e948-4917-8b2a-7b8d15379d1d.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/1b0ca2c3-aea5-4a27-bd89-46874eeb4934.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/151bbf66-e948-4917-8b2a-7b8d15379d1d.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/1b0ca2c3-aea5-4a27-bd89-46874eeb4934.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/151bbf66-e948-4917-8b2a-7b8d15379d1d.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/1b0ca2c3-aea5-4a27-bd89-46874eeb4934.jpg'];
export function InstagramFeed() {
  return <section id="instagram" className="w-full bg-vm-bg py-28 lg:py-36" data-id="element-113" data-mp="1f0r82ueb8zwf">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-114" data-mp="1a0d901uot0aj">
        <div className="max-w-4xl" data-id="element-115" data-mp="1a2zgk1hkvfsr">
          <SectionLabel data-id="element-116" data-mp="2xufg9gb1zciz">Instagram</SectionLabel>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3" data-id="element-117" data-mp="2xsujdk19nhhy">
          {POSTS.map((src, i) => <motion.a key={i} href="https://www.instagram.com/vivomedia.uy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.06
        }} className="group relative aspect-square overflow-hidden" data-id="element-118" data-mp="2ou96o5ih6wp3" data-mpi={i}>
              <img src={src} alt={`Publicación de Instagram de Vivo Media ${i + 1}`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-119" data-mp="2a65zissp5eyp" />
              <div className="absolute inset-0 bg-vm-navy/55 transition-colors group-hover:bg-vm-navy/25" data-id="element-120" data-mp="216ivdz8l1v1y" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100" data-id="element-121" data-mp="1xrfh0lee39p">
                <PlayIcon className="h-10 w-10 text-white" data-id="element-122" data-mp="3u2liyy31pefh" />
              </div>
            </motion.a>)}
        </div>

        <div className="mt-12 flex justify-center" data-id="element-123" data-mp="3p4a7yk10kxvo">
          <a href="https://www.instagram.com/vivomedia.uy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-[4px] border-2 border-vm-electric px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-white transition-colors hover:bg-vm-electric" data-id="element-124" data-mp="pnu0wxut4azc">
            <InstagramIcon className="h-5 w-5" data-id="element-125" data-mp="31dwd6lr1okxe" />
            Ver más en Instagram
          </a>
        </div>
      </div>
    </section>;
}